import { render, staticRenderFns } from "./HistoryTable02.vue?vue&type=template&id=4835921e&scoped=true&"
import script from "./HistoryTable02.vue?vue&type=script&lang=js&"
export * from "./HistoryTable02.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTable02.vue?vue&type=style&index=0&id=4835921e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835921e",
  null
  
)

export default component.exports